import { useEffect, useState } from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { useEngagementEditor } from './EngagementEditorContext';
import { CriteriaWeighting } from './CriteriaWeighting';
import { DetailedFunctionalityMatrix } from './DetailedFunctionalityMatrix';
import { LoadError } from '../LoadError';

export const FeatureMatrixPanel = () => {
  const { canEdit, functionalityMatrix } = useEngagementEditor();
  const { criteria, failed, refresh, updateCriterion, selectFeature } = functionalityMatrix;
  const [showDetail, setShowDetail] = useState(false);

  useEffect(() => {
    refresh?.();
  }, [refresh]);

  const loadError = failed && (
    <LoadError
      subject="the Functionality Matrix"
      consequence={criteria ? 'it may not show the latest selections' : 'there is nothing to show yet'}
      onRetry={refresh}
    />
  );

  if (!criteria) {
    if (loadError) return loadError;
    return (
      <Box className="flex justify-center p-12">
        <CircularProgress />
      </Box>
    );
  }

  if (criteria.length === 0) {
    return (
      <Alert severity="info">
        This engagement was created before the Functionality Matrix existed, so it has none.
      </Alert>
    );
  }

  if (showDetail) {
    return (
      <Box className="flex flex-col gap-4">
        {loadError}
        <DetailedFunctionalityMatrix
          criteria={criteria}
          canEdit={canEdit}
          onChangeCriterion={updateCriterion}
          onSelectFeature={selectFeature}
          onBack={() => setShowDetail(false)}
        />
      </Box>
    );
  }

  return (
    <Box className="flex flex-col gap-4">
      {loadError}
      <CriteriaWeighting
        criteria={criteria}
        canEdit={canEdit}
        onChangeCriterion={updateCriterion}
        onOpenDetail={() => setShowDetail(true)}
      />
    </Box>
  );
};
